export default function autoSearch() {
	const words = document.querySelectorAll('.c-auto-search__word-second');

	words.forEach((wordElement) => {
		const wordCount = wordElement.children.length;
		let step = 0;

		// Calculate the percentage each step should move
		const stepPercentage = 100 / (wordCount) + 2;

		const updateWordPosition = (element, position, useTransition = true) => {
			const el = element;
			el.style.transition = useTransition ? '1s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
			el.style.transform = `translateY(-${stepPercentage * position}%)`;
		};

		const animate = () => {
			// If we've shown all words, reset
			if (step >= wordCount) {
				step = 0;
				updateWordPosition(wordElement, 0, false);
				// Small delay before starting next cycle
				setTimeout(() => {
					step = 1;
					updateWordPosition(wordElement, step);
				}, 50);
				return;
			}

			updateWordPosition(wordElement, step);
			step += 1;
		};

		// Start the animation loop
		animate();
		setInterval(animate, 3500);
	});
}
